const REGISTERED_USER_REQUIRED_MESSAGE =
  'Registered user was expected, but guest user has been received.'

export const REGISTERED_ACCESS_ONLY_TOAST =
  'El acceso es solo para usuarios registrados'

function collectErrorTexts(error: unknown): string[] {
  if (!error || typeof error !== 'object') return []

  const err = error as {
    message?: string
    response?: {
      data?: {
        message?: string
        data?: { message?: string }
      }
    }
  }

  return [
    err.message,
    err.response?.data?.message,
    err.response?.data?.data?.message,
  ].filter((value): value is string => typeof value === 'string' && value.length > 0)
}

/**
 * True when the gateway rejected a guest token on an auth: 'private' route.
 */
export function isRegisteredUserRequiredError(error: unknown): boolean {
  return collectErrorTexts(error).some((text) => text.includes(REGISTERED_USER_REQUIRED_MESSAGE))
}
